import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { Link } from 'react-router-dom';
import ArrowLeft from 'lucide-react/dist/esm/icons/arrow-left.js';
import MessageCircle from 'lucide-react/dist/esm/icons/message-circle.js';
import { handleWhatsAppClick } from '../lib/whatsappTelemetry.js';
import './HomeFinalCta.css';

const WHATSAPP_URL = 'https://wa.me/972503969640?text=%D7%A9%D7%9C%D7%95%D7%9D%2C%20%D7%94%D7%92%D7%A2%D7%AA%D7%99%20%D7%9E%D7%90%D7%AA%D7%A8%20Printeam.%20%D7%99%D7%A9%20%D7%9C%D7%99%20%D7%A9%D7%90%D7%9C%D7%94';

const HomeFinalCta = () => {
  const reduceMotion = useReducedMotion();

  return (
    <motion.section
      className="home-final-cta"
      aria-labelledby="home-final-cta-title"
      initial={reduceMotion ? false : { opacity: 0, y: 28 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: '-90px' }}
      transition={{ duration: 0.65, ease: [0.22, 1, 0.36, 1] }}
    >
      <div className="home-final-cta__image">
        <img
          src="/hero_images/works_page/hero_34.webp"
          alt="קפוצ׳ונים מודפסים בצבעי בורדו ואפור"
          loading="lazy"
        />
      </div>

      <div className="home-final-cta__copy">
        <span className="home-final-cta__eyebrow">העיצוב שלכם. הבגד הנכון. תוצאה ברורה.</span>
        <h2 id="home-final-cta-title">מוכנים להתחיל?</h2>
        <p>בחרו את הבגד, העלו את העיצוב וקבלו מוקאפ לאישור לפני הייצור.</p>

        <div className="home-final-cta__actions">
          <Link className="home-final-cta__primary" to="/catalog">
            התחילו הזמנה <ArrowLeft size={20} />
          </Link>
          <a
            className="home-final-cta__secondary"
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            onClick={(event) => handleWhatsAppClick(event, 'home_final_cta')}
            onAuxClick={(event) => handleWhatsAppClick(event, 'home_final_cta')}
          >
            <MessageCircle size={20} /> דברו איתנו
          </a>
        </div>
      </div>
    </motion.section>
  );
};

export default HomeFinalCta;
